import React, { useState, useEffect } from 'react';
import localization from 'assets/localization/localization';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import Loader from 'components/sales/Loader/loader';
import PanelCardWithHeading from "../../../components/tickets/panelCardWithHeading";
import TableSection from "../../../components/sales/tableSection/tableSection";
import Layout from 'components/sales/layout/layout';
import queryString from 'query-string';
import {Button} from "react-bootstrap";
import $ from "jquery";
import CustomModal from "../../valetServices/modal";
import CsvFileUpload from 'components/sales/bulkUpload/CsvFileUpload';
import sampleCsvFile from 'assets/docs/sample_csv_file.csv';


const AssignmentForm = ({
    siteInfo,
    getReportee,
    reportee = [],
    location,
    search,
    searchInfo = [],
    newAssignee,
    newAssigneeRes = [],
    uploadcsvfile,
    uploadcsvfile_1 = [],

}) => {
    const [listData, setListData] = useState();
    const [assignmentType, setAssignmentType] = useState(queryString.parse(location.search)?.type)
    const [newAssigneeUser, setNewAssingeeUser] = useState("")
    const [siteIds, setSiteIds] = useState([]);
    const [isAllChecked, setIsAllChecked] = useState(false)
    const [oldAssignee, setOldAssignee] = useState("");
    const [type, setType] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [notify, setNotify] = useState("");
    const [count, setCount] = useState(0)
    const [csvUploadUrl, setCsvUploadUrl] = useState("");
    const [isCsvModal, setCsvModal] = useState(false);
    const [isUploaded, setIsuploaded] = useState(false);
    const [uploadResponse, setUploadResponse] = useState("");    

    const headers = (assignmentType === 'baSiteList' || assignmentType === 'installationContractList') ?
        ['Site Number', 'Site Name', 'Assigned To', 'Action'] : ['Lead Number', 'Business Name', 'Assigned To', 'Action'];

    useEffect(() => {
        const tableData = (assignmentType === 'baSiteList' || assignmentType === 'installationContractList') ?
            ['site_no', 'client_name', 'assigned_to', 'action'] : ['lead_no', 'client_name', 'assigned_to', 'action'];

        if (searchInfo.length > 0) {
            const data = searchInfo.map((element) =>
                (assignmentType === 'baSiteList' || assignmentType === 'installationContractList') ?
                Object.assign(
                    {},
                    ...tableData.map((key) => (key === 'action' ?  {
                        ['action']:
                            <input type="checkbox"
                                   value={element?.site_id}
                                   onChange={(e) => handleAddRemoveSiteIds(e, element?.site_id)}
                                   required
                            /> }:
                        { [key]: element[key] })),
                ) :
                    Object.assign(
                        {},
                        ...tableData.map((key) => (key === 'action' ?  {
                                ['action']:
                                    <input type="checkbox"
                                           value={element?.id}
                                           onChange={(e) => handleAddRemoveSiteIds(e, element?.id)}
                                           required
                                    />
                        }:
                            { [key]: element[key] })),
                    ),
            );

            if (data) {
                const newData = data.map(function (obj) {
                    obj['id'] = obj['site_id']; // Assign new key
                    delete obj['site_id']; // Delete old key
                    return obj;
                });
                newData && setListData(newData);
            }
        }
    }, [searchInfo]);

    useEffect( () => {
        let details = JSON.parse(localStorage.getItem(assignmentType));
        let type = assignmentType === 'baSiteList' ? 2 : assignmentType === 'installationContractList'  ? 1 : assignmentType === 'businessList' ? 3 :"";

        (async () => {
            setType(type)
            setOldAssignee(details?.reportee)
            let res = await search(details, type)
        })()
    }, [assignmentType])

    useEffect(() => {
        (async () => {
            let type = assignmentType === 'baSiteList' ? 2 : assignmentType === 'installationContractList'  ? 1 : assignmentType === 'businessList' ? 3 :""
            await getReportee(type)
        })();
    }, [getReportee]);

    const handleOnSubmitForm = async () => {
        if(newAssigneeUser === ""){
            alert("new assignee is required")
            return false
        }

        if(isAllChecked){
            if(searchInfo.length > 0) {
                searchInfo.map((element) => {
                    siteIds.push(element?.site_id !== null && element?.site_id !== undefined ? element?.site_id : element?.id)
                })
            }
        }

        setIsLoading(true)
        let res = await newAssignee(
            {
                'new_assigned_id':newAssigneeUser,
                'ids':siteIds,
                'type':type
            }
        )
        setNotify(200)
        setIsLoading(false)
        setCount(count+1)
    }

    const handleAddRemoveSiteIds = (e, id) => {
        if(e.target.checked){
            siteIds.push(parseInt(id))
            console.log("siteIds "+siteIds)
            setSiteIds(siteIds)
        } else{
            var index = siteIds.indexOf(parseInt(id));
            if (index !== -1) {
                siteIds.splice(index, 1);
            }
        }
    }

    const makeAllChecked = (e) => {
        if(e.target.checked){
            setIsAllChecked(true)
            $("input[type=checkbox]").prop('checked', true)
        }else{
            siteIds.length = 0
            setSiteIds([])
            setIsAllChecked(false)
            $("input[type=checkbox]").prop('checked', false)
        }
    }

    const handleFileChange = (val) => csvUploadUrl(val);

    const handleCsvSubmit = async () => {
    setIsLoading(true);

    try {
        const res = await uploadcsvfile(csvUploadUrl.val, assignmentType);
        if (res) {
            setUploadResponse({
                failed_csv_url: res?.response?.data?.failed_csv_url || null,
                skipped_count: res?.response?.data?.skipped_count || 0,
                inserted: res?.response?.data?.inserted || [],
                });
            setIsuploaded(true);
        } else {
            setIsuploaded(false);
            setUploadResponse(null);
        }
    } catch (err) {
        console.error("CSV upload failed:", err);
        setIsuploaded(false);
        setUploadResponse(null);
    }
    setIsLoading(false);
};


    return (
        <Layout
            title={localization.siteList}
            isLoading={isLoading}
            isGoback
        >
        <>
                <div className="row">
                    {newAssigneeRes !== [] && notify !== 200 &&
                        <CustomModal msg={newAssigneeRes?.response?.message} isPageLoad={true}  click={count}/>}
                    {newAssigneeRes !== [] && notify === 200 &&
                        <CustomModal msg={newAssigneeRes?.response?.message}  isPageLoad={true} click={count}/>}
                    <div className="col-md-3 col-sm-12">
                        <DropDownInput
                            label={localization.changeAssignedUser}
                            data={reportee}
                            getIdValue={async (val) => {
                                setNewAssingeeUser(val.id)
                            }}
                        />
                    </div>
                    <div className="col-md-3 col-sm-12 mb-4 d-flex align-items-end">
                    <Button className="w-100"
                             onClick={handleOnSubmitForm}>{localization.ChangeAssignee}
                            </Button>
                    
                    </div>
                    <div className="col-md-6 col-sm-12 d-flex justify-content-end align-items-end mb-4">
                        {sampleCsvFile && (
                            <a
                            className="btn btn-primary mr-3"
                            href={sampleCsvFile}
                            download="sample_csv_file.csv"
                            >
                            Download Sample CSV
                            </a>
                        )}
                        
                    <Button className="btn btn-primary" onClick={() => setCsvModal(true)} >Bulk Upload File</Button>
                    </div>
                </div>              
                {searchInfo.length > 0 && (
                    <div style={{"overflow":"hidden"}}>
                        <PanelCardWithHeading title={localization.siteDetails}>
                            <>
                                <div>
                                    <p style={{"marginLeft":"86%", "marginBottom":"-21px"}}>Assign All</p>
                                    <input type="checkbox"
                                           value=""
                                           onChange={() => {}}
                                           required
                                           style={{"position":"relative","left":"44%","marginBottom":"29px"}}
                                           onClick={(e) => {makeAllChecked(e)}}
                                    />
                                </div>

                                <TableSection
                                    data={listData}
                                    isId={false}
                                    headers={headers}
                                    detailList={searchInfo}
                                    srNo = {1}
                                />
                            </>
                        </PanelCardWithHeading>
                    </div>
                )}
                <Loader isLoading={isLoading} />
        </>
        <CsvFileUpload
            // sampleData={{ file_url: sampleCsvFile }}
            // handleModalHide={() => {
            //     setIsuploaded(false);
            //     setCsvModal(false);
            //     setCsvUploadUrl("");
            // }}
            setCsvUploadUrl={setCsvUploadUrl}
            isCsvModal={isCsvModal}
            handleFileChange={handleFileChange}
            uploadResponse={uploadResponse}
            isUploaded={isUploaded}
            setIsuploaded={setIsuploaded}
            setCsvModal={setCsvModal}
            redirectUrl={`/brand-activation/sites-listing`}   
            redirectName="Done"
            handleCsvSubmit = {handleCsvSubmit}
            />
        </Layout>
    );

};

export default AssignmentForm;